//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchSwimmingOrderDetail } from '@/api/PMS/swimming/swimmingOrder';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      if (this.keyValue > 0) {
        fetchSwimmingOrderDetail({
          id: this.keyValue
        }).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {};
      }
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};